export { default as ResetPasswordView } from "./ResetPasswordView";
